import * as R from "ramda";

export default form => (R.prop("base_module_id", form) ? 3 : 2);
